module.exports = require("@swa-ui/dotcom/src/DotcomPageLayout/DotcomPageLayout.module.scss");